"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Catalogues = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../../api");
var _constants = require("../../../constants");
var _navigation = require("../../../context/navigation");
var _hooks = require("../../../hooks");
var _useTranslations = require("../../../hooks/useTranslations");
var _formatValidity = require("../../../utils/formatValidity");
var _common = require("../../common");
var _CataloguesSkeleton = require("./CataloguesSkeleton");
var _CurrentCatalogue = require("./CurrentCatalogue");
var _NextCatalogue = require("./NextCatalogue");
var _constant = require("./constant");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Catalogues = () => {
  const {
    catalogues,
    loading
  } = (0, _api.useGetCatalogues)();
  const {
    shopSectionItems: items
  } = (0, _navigation.useBurgerMenu)();
  const isMobile = (0, _hooks.useIsMobile)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    culture,
    timeZone
  } = (0, _culture.useCulture)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  // istanbul ignore next @preserve -- just formatting
  const formatValidityDate = (0, _react.useCallback)(date => (0, _culture.formatDate)(date, _culture.DateFormat.Custom, culture, timeZone, {
    customPattern: 'dd/MM'
  }), [culture, timeZone]);
  const sendAnalyticsData = (0, _react.useCallback)(() => {
    UserAction.dispatch(_constants.CLICK_CATALOGUE_DETAIL);
  }, []);
  const catalogueDataFromItems = (0, _react.useMemo)(() => {
    const link = items.find(e => e.linkType === 'Catalogue');
    const catalogueCurrent = link?.children.find(e => e.linkType === 'DigitalCatalogueCurrent');
    const catalogueNext = link?.children.find(e => e.linkType === 'DigitalCatalogueNext');
    const isCatalogueNextValid = Boolean(!isMobile && catalogueNext?.id && catalogueNext.imageUrl && catalogueNext.title && catalogueNext.url);
    const linkToAllCatalogues = link?.children.find(e => e.linkType === 'Catalogues')?.url;
    return {
      catalogueCurrent,
      catalogueNext,
      isCatalogueNextValid,
      linkToAllCatalogues
    };
  }, [items, isMobile]);
  if (loading || items.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CataloguesSkeleton.CataloguesSkeleton, {});
  }
  const {
    catalogueCurrent,
    catalogueNext,
    isCatalogueNextValid,
    linkToAllCatalogues
  } = catalogueDataFromItems;
  if (!catalogueCurrent?.id || !catalogueCurrent.imageUrl || !catalogueCurrent.title || !catalogueCurrent.url) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CatalogueWrapper, {
      "data-testid": getTestId(_constant.CATALOGUES_ROOT),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentCatalogue.CurrentCatalogue, {
        catalogue: {
          ...catalogueCurrent,
          validity: (0, _formatValidity.formatValidity)(catalogueCurrent.id, catalogues, formatValidityDate)
        },
        isMobile: isMobile,
        linkToAllCatalogues: linkToAllCatalogues,
        onClick: sendAnalyticsData
      }), isCatalogueNextValid && catalogueNext ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_NextCatalogue.NextCatalogue, {
        catalogue: {
          ...catalogueNext,
          validity: (0, _formatValidity.formatValidity)(catalogueNext.id ?? '', catalogues, formatValidityDate)
        },
        onClick: sendAnalyticsData
      }) : null]
    }), !isMobile && linkToAllCatalogues ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CallToActionWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CallToAction, {
        "data-testid": getTestId(_common.CATALOGUES_SEE_ALL),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CTAText, {
          "data-testid": getTestId(_common.CTA_TEXT),
          variant: "subtitle1",
          children: translations.callToActionCatalogueText
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CatalogueDetailButton, {
          fullWidth: true,
          variant: "outlined",
          "data-testid": getTestId(_common.CATALOGUES_SEE_ALL_LINK),
          href: linkToAllCatalogues,
          children: translations.seeAllCatalogues
        })]
      })
    }) : null]
  });
};
exports.Catalogues = Catalogues;
